import { useMutation } from '@apollo/client';

import { PurchasesWarningModal as PurchasesWarningModalView } from './purchases-warning-modal';
import { IPurchasesWarningModalProps } from './purchases-warning-modal.models';
import { UPDATE_NOTIFICATION } from '../../../../../../../graphql/notifications/mutations/update-notification';
import { useActionsInProgress } from '../../../../../../../graphql/preloader/actions/actions-in-progress';
import { useCancellablePromise } from '../../../../../../../hooks/use-cancellable-promise/use-cancellable-promise';
import { promiseErrorCallbacks } from '../../../../../../../utils/promise/set-promise-error-callbacks';

export const PurchasesWarningModal = ({
  notificationId, updateNotifications: updateNotificationsInCache, onNavigate, onClose, ...props
}: IPurchasesWarningModalProps): JSX.Element => {
  const [updateNotification] = useMutation(UPDATE_NOTIFICATION);
  const { addActionInProgress, removeActionInProgress } = useActionsInProgress();
  const {
    makeCancellablePromise,
    CancelledPromiseOnUnmountError,
  } = useCancellablePromise();

  const handleWarningModalClose = async () => {
    try {
      addActionInProgress();

      await makeCancellablePromise(
        updateNotification({
          variables: {
            notificationId,
          },
        }),
      );

      updateNotificationsInCache([notificationId]);
    } catch (error) {
      if (error instanceof CancelledPromiseOnUnmountError) {
        return;
      }

      if (promiseErrorCallbacks.anyError) {
        promiseErrorCallbacks.anyError();
      }
    } finally {
      removeActionInProgress();
      onClose!();
    }
  };

  const handleActionButtonClick = async () => {
    await handleWarningModalClose();
    onNavigate();
  };

  return (
    <PurchasesWarningModalView
      {...props}
      onClose={handleWarningModalClose}
      onActionButtonClick={handleActionButtonClick}
    />
  );
};
